import dayjs from 'dayjs'

import { TaskStatus } from 'src/graphql/types/tasks'

interface FollowUpTask {
  status: string
  dueDate?: string | Date | null
}

export interface FollowUpDescription {
  label: string
  className: string
}

/** Footer text for a note that spawned a follow-up task. */
export const describeFollowUp = (
  task: FollowUpTask,
  now = new Date()
): FollowUpDescription => {
  const day = task.dueDate ? dayjs(task.dueDate).format('MMM D') : null
  const prefix = day ? `Follow-up ${day}` : 'Follow-up'

  if (task.status === TaskStatus.COMPLETED) {
    return {
      label: `${prefix} · Completed`,
      className: 'text-doubleNickel-success-600',
    }
  }
  if (task.status === TaskStatus.CANCELLED) {
    return {
      label: `${prefix} · Cancelled`,
      className: 'text-doubleNickel-gray-400',
    }
  }
  if (task.dueDate && dayjs(task.dueDate).isBefore(now)) {
    return {
      label: `${prefix} · Overdue`,
      className: 'text-doubleNickel-error-500',
    }
  }
  return { label: `${prefix} · Open`, className: 'text-doubleNickel-brand-600' }
}
